import { ButtonLink } from '@asgard/ui-library';
import { faCheckCircle, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2, Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import ServiceEventTracking from 'services/service.event-tracking';
import { getPublicPath } from 'utils/paths';
import {
  StyledFeature,
  StyledHighlight,
  StyledHighlightIcon,
  StyledHighlightTitle,
  StyledWrapper
} from './DailyFeatures.styled';

const DailyFeatures: React.FC = () => {
  const { t } = useI18n('manfred-daily');

  return (
    <StyledWrapper>
      <Heading2 editorial>{t('manfred-daily.features.title')}</Heading2>
      <StyledFeature>
        <div>
          <Heading3 editorial alignLeft>
            {t('manfred-daily.features.telegram-title')}
          </Heading3>
          <HtmlTrans
            ns={'manfred-daily'}
            i18nKey={'manfred-daily.features.telegram-desc'}
          />
        </div>
        <img src={getPublicPath(`/images/manfredDaily/telegram.png`)} alt="" />
      </StyledFeature>
      <StyledHighlight>
        <StyledHighlightIcon>
          <FontAwesomeIcon icon={faPaperPlane} />
        </StyledHighlightIcon>
        <StyledHighlightTitle>
          {t('manfred-daily.features.highlight-title')}
        </StyledHighlightTitle>
        <HtmlTrans
          ns={'manfred-daily'}
          i18nKey={'manfred-daily.features.highlight-desc'}
        />

        <ButtonLink
          schema="brand1"
          variant="hard"
          size="xs"
          label={t('manfred-daily.features.highlight-cta')}
          startIcon={faCheckCircle}
          href="https://t.me/getmanfred"
          target="_blank"
          onClick={() => {
            ServiceEventTracking.trackLandingCtaClicked(
              'manfred-daily-abrir-telegram'
            );
          }}
        />
      </StyledHighlight>
      <StyledFeature className="reverse">
        <div>
          <Heading3 editorial alignLeft>
            {t('manfred-daily.features.publish-title')}
          </Heading3>
          <HtmlTrans
            ns={'manfred-daily'}
            i18nKey={'manfred-daily.features.publish-desc'}
          />
          <ButtonLink
            schema="brand1"
            variant="hard"
            size="xs"
            label={t('manfred-daily.features.publish-cta')}
            endIcon={faArrowRight}
            href="https://getmanfred.typeform.com/to/gKjXJi"
            target="_blank"
            onClick={() => {
              ServiceEventTracking.trackLandingCtaClicked(
                'manfred-daily-contacta-typeform'
              );
            }}
          />
        </div>
        <img src={getPublicPath(`/images/manfredDaily/ads.png`)} alt="" />
      </StyledFeature>
      <StyledFeature>
        <div>
          <Heading3 editorial alignLeft>
            {t('manfred-daily.features.report-title')}
          </Heading3>
          <HtmlTrans
            ns={'manfred-daily'}
            i18nKey={'manfred-daily.features.report-desc'}
          />
        </div>
        <img src={getPublicPath(`/images/manfredDaily/report.png`)} alt="" />
      </StyledFeature>
    </StyledWrapper>
  );
};

export default DailyFeatures;
